import { Button, Card, Heading, Text } from '@ui/themed';
import { t } from 'i18next';
import { INTERCOM_TRIGGER } from '../../../constants/intercom';
import type { I18nPrefix } from '../../../i18n/prefix';
import { FeatureIconTile } from './feature-icon-tile';

const BASE = 'features:explore.pages.features_page.ai_assistant' satisfies I18nPrefix;

export function AiAssistantCard() {
  return (
    <Card size="sm" showBorder>
      <div className="flex w-full flex-wrap items-center justify-between gap-3">
        <span className="flex min-w-0 items-center gap-3">
          <FeatureIconTile icon="chat" />
          <span className="flex min-w-0 flex-col gap-0.5 text-start">
            <Heading level="span" style="sm">
              {t(`${BASE}.title`)}
            </Heading>
            <Text variant="secondary">{t(`${BASE}.subtitle`)}</Text>
          </span>
        </span>
        <span className={INTERCOM_TRIGGER.aiAssistant}>
          <Button variant="primary">{t(`${BASE}.cta`)}</Button>
        </span>
      </div>
    </Card>
  );
}
